import { render, staticRenderFns } from "./FooterColumnMobile.vue?vue&type=template&id=29ae5b12&scoped=true"
import script from "./FooterColumnMobile.vue?vue&type=script&lang=js"
export * from "./FooterColumnMobile.vue?vue&type=script&lang=js"
import style0 from "./FooterColumnMobile.vue?vue&type=style&index=0&id=29ae5b12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ae5b12",
  null
  
)

export default component.exports